import React, {useCallback, useEffect, useState} from 'react';
import { useWeb3React } from '@web3-react/core';
import styled from 'styled-components/macro';
import useSortableData from "./UseSortableData";
import {NavLink} from "react-router-dom";

import LandRegistration from '../artifacts/src/contracts/LandRegistration.sol/LandRegistration';
import LoanOriginator from '../artifacts/src/contracts/LoanOriginator.sol/LoanOriginator';
import SPVWallet from '../artifacts/src/contracts/SPVWallet.sol/SPVWallet';
import ManagementCompany from '../artifacts/src/contracts/ManagementCompany.sol/ManagementCompany'
import LoanPool from '../artifacts/src/contracts/LoanPool.sol/LoanPool'

import Spinner from "./Spinner";
import CreateLoanModal from "./CreateLoanModal";
import PayLoanModal from "./PayLoanModal";
import CloseMarketModal from "./CloseMarketModal";
import CreateMarketModal from "./CreateMarketModal";
import LiquidateLandModal from "./LiquidateLandModal";
import CurrencyModal from "./CurrencyModal";
import {parseUnits} from "@ethersproject/units";

var BigNumber = require("big-number");

const DashboardPage = styled.div`
    width: 100%;
    font-family: Lato;
    font-style: normal;
`

const TitleRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 103px;
    margin-left: 152px;
    width: 80%;
`

const Title = styled.div`
    width: 294px;
    height: 54px;

    font-weight: bold;
    font-size: 30px;
    line-height: 180%;
    /* identical to box height, or 54px */

    text-transform: capitalize;

    color: #000000;
`

const ActionButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-left: auto;
    align-items: center;
    gap: 42px;

`

const FlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    justify-content: center;
    z-index: 1;

    width: 80%;
    margin-left: 10%;
    margin-top: 48px;
`

const TableContainer = styled.div`
    width: 100%;
    min-height: 60vh;
`

const StyledNavLink = styled(NavLink)`
    border: none;
    background: transparent;
    color: black;
    padding-left: 25px;
    text-decoration: none;

    cursor: pointer;
`
const StyledTable = styled.table`
  border: none;
  border-collapse: separate;
  border-spacing: 0px 20px;
  width: 100%;
  font-weight: bold;

  thead {
    width: 100%;
    font-weight: bold;
    font-size: 20px;
    line-height: 180%;
    text-decoration: underline;
  }
    
  th {
    border: none;
    padding-left: 10px;
    text-align: left;
  }  

  td {
    width: 5%;
  }
  
  #name {
    width: 15%;
    padding-left: 5px;
  }
  
  #action {
    width: 25%;
  }

  
  tbody tr {
    width: 100%;
    height: 66px;
    
    vertical-align: middle;
    
    background: #FFFFFF;
    box-shadow: 4px 6px 20px rgba(176, 176, 176, 0.15);
 
    :hover {
      background-color: #f5f5f5;
    }
  }
`;

const HeaderColumn = styled.button`
    font-weight: bold;
    font-size: 20px;
    border: none;
    background: transparent;
    text-decoration: underline;
    
    cursor: pointer;
`

const ActionButtonRow = styled.div`
    display: flex;
    flex-direction: row;
`

const DECIMALBASE = 100000;

const MarketDashboardPage = () => {
    const web3Context = useWeb3React();
    const [loading, setLoading] = useState(true);
    const [boardMembers, setBoardMembers] = useState();
    const [loanOriginatorSC, setLoanOriginatorSC] = useState({
        address: process.env.REACT_APP_LOANORIGINATOR,
        abi: LoanOriginator.abi
    });

    const [SPVWalletSC, setSPVWalletSC] = useState({
        address: process.env.REACT_APP_SPVWALLET_ADDRESS,
        abi: SPVWallet.abi
    });

    const [activeDevelopers, setActiveDevelopers] = useState([]);

    const [ManagementCompanySC] = useState({
        address: process.env.REACT_APP_MCADMIN_ADDRESS,
        abi: ManagementCompany.abi
    });

    const [landRegistrationSC, setLandRegistrationSC] = useState({
        address: process.env.REACT_APP_LANDREGISTRATION_ADDRESS,
        abi: LandRegistration.abi
    });

    const [activeLoanPools, setActiveLoanPools] = useState({
        activeLoanPoolIDs: [],
        activeLoanPoolInfos: [],
    });

    const currencies = CurrencyModal();
    // cache for loanPool currencies info
    const [loanPoolCurrencyBase, setLoanPoolCurrencyBase] = useState({});

    const { items, requestSort, sortConfig } = useSortableData(activeLoanPools.activeLoanPoolInfos);

    const getActiveLoanPools = useCallback(async() => {
        let activeLoanPoolIDs = [];
        let activeLoanPoolInfos = [];
        const ethLibrary = web3Context.library.eth;
        const loanOriginatorContract = new ethLibrary.Contract(
            loanOriginatorSC.abi,
            loanOriginatorSC.address
        );
        activeLoanPoolIDs = await loanOriginatorContract.methods
            .getActiveLoanPoolIDs()
            .call();

        const totalActiveLoanPoolID = activeLoanPoolIDs.length;
        let newLoanPoolArray = [];
        let newLoanPoolObject = {};
        let CURRENCYBASE = 10 ** 18;
        let currency;
        let currencyName;
        let loanPoolCurrencyBaseCache = {};
        // load developer info by each ID

        for(var i = 1; i < totalActiveLoanPoolID; i++) {
            newLoanPoolArray = await loanOriginatorContract.methods.getLoanPoolInfoByID(activeLoanPoolIDs[i]).call();
            const loanPoolAddress = await loanOriginatorContract.methods.getLoanPoolByID(activeLoanPoolIDs[i]).call();
            currency = currencies.find(c => c.address.toLowerCase() == newLoanPoolArray[7].toString().toLowerCase());
            CURRENCYBASE = currency === undefined ? 10 ** 18 : 10 ** currency.decimal;
            currencyName = currency === undefined ? "N/A" : currency.name;

            loanPoolCurrencyBaseCache[activeLoanPoolIDs[i].toString()] = CURRENCYBASE;

            newLoanPoolObject = {
                loanPoolID: activeLoanPoolIDs[i],
                loanPoolAddress: loanPoolAddress,
                loanPoolName: newLoanPoolArray[0],
                poolDebt: Number(newLoanPoolArray[1]) / CURRENCYBASE,
                poolReserve: Number(newLoanPoolArray[2]) / CURRENCYBASE,
                marketsize: (Number(newLoanPoolArray[1])+Number(newLoanPoolArray[2])) / CURRENCYBASE,
                rateToBorrow: newLoanPoolArray[3] / DECIMALBASE * 100,
                maxRate: Number(newLoanPoolArray[4]) / DECIMALBASE * 100,
                // uint    developerID;
                minRate: Number(newLoanPoolArray[5]) / DECIMALBASE * 100,
                currentUltilizationRate: (newLoanPoolArray[6]) / DECIMALBASE * 100,
                currency: newLoanPoolArray[7],
                currencyBase: CURRENCYBASE,
                status: newLoanPoolArray[8].toString(),
                currencyName: currencyName
            }

            activeLoanPoolInfos.push(newLoanPoolObject);

        }

        setLoanPoolCurrencyBase(loanPoolCurrencyBaseCache);
        setActiveLoanPools({activeLoanPoolIDs, activeLoanPoolInfos});
    }, [loanOriginatorSC, web3Context]);

    const loadBoardMembers = useCallback(async() => {
        const ethLibrary = web3Context.library.eth;
        const ManagementCompanyContract = new ethLibrary.Contract(
            ManagementCompanySC.abi,
            ManagementCompanySC.address
        );

        const activeBoardMembers = await ManagementCompanyContract.methods
            .getActiveMCBoard()
            .call();

        setBoardMembers(activeBoardMembers.slice(1));

        }, [web3Context, ManagementCompanySC]);


    const createLoanPool = useCallback(async (minRate, maxRate, ultLimit, currency, loanPoolName) => {
        const ethLibrary = web3Context.library.eth;
        const loanOriginatorContract = new ethLibrary.Contract(
            loanOriginatorSC.abi,
            loanOriginatorSC.address
        );

        await loanOriginatorContract.methods
            .createLoanPool(Number(minRate) * 1000, Number(maxRate) * 1000, ultLimit * 1000, currency.toString(), loanPoolName)
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });

    }, [ManagementCompanySC, web3Context, loanOriginatorSC, landRegistrationSC]);

    const withdrawFund = useCallback(async (loanPoolID, landID, loanAmount, maturity, projectDescription) => {
        const ethLibrary = web3Context.library.eth;
        const SPVWalletContract = new ethLibrary.Contract(
            SPVWalletSC.abi,
            SPVWalletSC.address
        );

        const dateTime = new Date(maturity.current.state.date).getTime();
        const timestamp = Math.floor(dateTime / 1000);

        const loanOriginatorContract = new ethLibrary.Contract(
            loanOriginatorSC.abi,
            loanOriginatorSC.address
        );

        const reloadedLoanPoolAddress = await loanOriginatorContract.methods
            .getLoanPoolByID(loanPoolID)
            .call();

        const LoanPoolContract = new ethLibrary.Contract(
            LoanPool.abi,
            reloadedLoanPoolAddress
        );

        const loanPoolInfoArray = await LoanPoolContract
            .methods
            .getLoanPoolInfo()
            .call();

        const reloadedLoanPoolCurrency = loanPoolInfoArray[7];

        const currency = currencies.find(c => c.address.toLowerCase() === reloadedLoanPoolCurrency.toString().toLowerCase());
        const decimal = currency === undefined ? 18 : currency.decimal;
        const dec = web3Context.library.utils.toBN(decimal);
        let bnAmount;
        let exactAmount;

        // work around
        if(loanAmount >= 0) {
            exactAmount =  parseUnits(loanAmount, decimal);
        } else {
            exactAmount = 0;
        }

        // uint amount, uint loanPoolID, uint landID, uint closeDate, string calldata projectDescription
        await SPVWalletContract.methods
            .loanPoolDrawFund(exactAmount, Number(loanPoolID), Number(landID), timestamp, projectDescription)
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });
    }, [ManagementCompanySC, web3Context, SPVWalletSC]);

    const payLoan = useCallback(async (currency, loanAmount, loanPoolID, loanEntityID) => {
        const ethLibrary = web3Context.library.eth;
        const managementCompanyContract = new ethLibrary.Contract(
            ManagementCompanySC.abi,
            ManagementCompanySC.address
        );

        const loanOriginatorContract = new ethLibrary.Contract(
            loanOriginatorSC.abi,
            loanOriginatorSC.address
        );

        const reloadedLoanPoolAddress = await loanOriginatorContract.methods
            .getLoanPoolByID(loanPoolID)
            .call();

        const LoanPoolContract = new ethLibrary.Contract(
            LoanPool.abi,
            reloadedLoanPoolAddress
        );

        const loanPoolInfoArray = await LoanPoolContract
            .methods
            .getLoanPoolInfo()
            .call();

        const reloadedLoanPoolCurrency = loanPoolInfoArray[7];

        const reloadedcurrency = currencies.find(c => c.address.toLowerCase() === reloadedLoanPoolCurrency.toString().toLowerCase());
        const decimal = reloadedcurrency === undefined ? 18 : reloadedcurrency.decimal;
        const dec = web3Context.library.utils.toBN(decimal);
        let bnAmount;
        let exactAmount;

        // work around
        if(loanAmount >= 0) {
            exactAmount =  parseUnits(loanAmount, decimal);
        } else {
            exactAmount = 0;
        }


        await managementCompanyContract.methods
            .payLoanRequest(currency, exactAmount, loanPoolID, loanEntityID)
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });
    }, [ManagementCompanySC, web3Context, loanOriginatorSC]);

    const liquidateLand = useCallback(async (loanAmount, loanPoolID, loanEntityID) => {
        const ethLibrary = web3Context.library.eth;
        const managementCompanyContract = new ethLibrary.Contract(
            ManagementCompanySC.abi,
            ManagementCompanySC.address
        );
        const loanOriginatorContract = new ethLibrary.Contract(
            loanOriginatorSC.abi,
            loanOriginatorSC.address
        );

        const reloadedLoanPoolAddress = await loanOriginatorContract.methods
            .getLoanPoolByID(loanPoolID)
            .call();

        const LoanPoolContract = new ethLibrary.Contract(
            LoanPool.abi,
            reloadedLoanPoolAddress
        );

        const loanPoolInfoArray = await LoanPoolContract
            .methods
            .getLoanPoolInfo()
            .call();

        const reloadedLoanPoolCurrency = loanPoolInfoArray[7];

        const reloadedCurrency = currencies.find(c => c.address.toLowerCase() === reloadedLoanPoolCurrency.toString().toLowerCase());
        const decimal = reloadedCurrency === undefined ? 18 : reloadedCurrency.decimal;
        const dec = web3Context.library.utils.toBN(decimal);
        let bnAmount;
        let exactAmount;

        // work around
        if(loanAmount >= 1) {
            bnAmount =  web3Context.library.utils.toBN(loanAmount);
            exactAmount ="0x"+ bnAmount.mul(web3Context.library.utils.toBN(10).pow(dec)).toString("hex");
        }
        else if (loanAmount > 0 && loanAmount < 1) {
            exactAmount = web3Context.library.utils.toBN(loanAmount * (10 ** decimal).toString());
        } else {
            exactAmount = 0;
        }
        await managementCompanyContract.methods
            .debtVoidRequest(exactAmount, loanPoolID, loanEntityID)
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });
    }, [ManagementCompanySC, web3Context, loanOriginatorSC]);


    const closeMarket = useCallback(async (loanPoolID) => {
        const ethLibrary = web3Context.library.eth;
        const loanOriginatorContract = new ethLibrary.Contract(
            loanOriginatorSC.abi,
            loanOriginatorSC.address
        );

        await loanOriginatorContract.methods
            .closeLoanPool(loanPoolID)
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });

    }, [ManagementCompanySC, web3Context, loanOriginatorSC]);

    const openMarket = useCallback(async (loanPoolID) => {
        const ethLibrary = web3Context.library.eth;
        const loanOriginatorContract = new ethLibrary.Contract(
            loanOriginatorSC.abi,
            loanOriginatorSC.address
        );

        await loanOriginatorContract.methods
            .openLoanPool(loanPoolID)
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });

    }, [ManagementCompanySC, web3Context, loanOriginatorSC]);

    const getActiveDeveloperDetails = useCallback(async() => {
        if(web3Context.account !== undefined && boardMembers !== undefined && boardMembers.includes(web3Context.account)) {
            let activeDeveloperIDs = [];
            let activeDeveloperInfos = [];
            const ethLibrary = web3Context.library.eth;
            const landRegistrationContract = new ethLibrary.Contract(
                landRegistrationSC.abi,
                landRegistrationSC.address
            );
            activeDeveloperIDs = await landRegistrationContract.methods
                .getActiveDeveloperIDs()
                .call();

            const totalActiveDeveloperID = activeDeveloperIDs.length;
            let newDeveloperArray = [];
            let newDeveloperObject = {};

            for (var i = 1; i < totalActiveDeveloperID; i++) {

                newDeveloperArray = await landRegistrationContract.methods.getDeveloperByID(activeDeveloperIDs[i]).call();
                newDeveloperObject = {
                    developerID: activeDeveloperIDs[i],
                    companyName: newDeveloperArray[0],
                    location: newDeveloperArray[1],
                    note: newDeveloperArray[2],
                    // uint    developerID;
                    loanLimit: Number(newDeveloperArray[4]),
                    loanBalance: Number(newDeveloperArray[5])
                }

                const newActiveLandIds = await landRegistrationContract
                    .methods
                    .getActiveLandIdsByDeveloperId(activeDeveloperIDs[i])
                    .call();

                newDeveloperObject.landIds = newActiveLandIds;
                let activeLandInfoArray = [];
                let newLandObject = {}
                let loadedDetailsArray = [];
                for(var j = 1; j < newActiveLandIds.length; j++) {
                    activeLandInfoArray = await landRegistrationContract.methods.getLandByID(newActiveLandIds[j]).call();

                    newLandObject = {
                        landID: newActiveLandIds[j],
                        // basic info
                        propertyIdentificationNumber: activeLandInfoArray[0],
                        propertyAddress: activeLandInfoArray[1],
                        propertyZoning: activeLandInfoArray[2],
                        note: activeLandInfoArray[3],
                        isReady: activeLandInfoArray[4],
                        // uint    landID; --5
                        developerID: activeLandInfoArray[6],
                        appraisalAmount: activeLandInfoArray[7],
                        appraisalDiscountPercent: activeLandInfoArray[8],
                        amountBorrowedByDeveloper: activeLandInfoArray[9]
                    }

                    loadedDetailsArray.push(newLandObject);
                }
                newDeveloperObject.landInfo = loadedDetailsArray;
                activeDeveloperInfos.push(newDeveloperObject);
            }
            setActiveDevelopers(activeDeveloperInfos);
        }
    }, [ManagementCompanySC, landRegistrationSC, web3Context, boardMembers]);

    const loadSCAddress = useCallback(async() => {
        const ethLibrary = web3Context.library.eth;
        const MCAdminContract = new ethLibrary.Contract(
            ManagementCompany.abi,
            process.env.REACT_APP_MCADMIN_ADDRESS
        );

        const LRSC = await MCAdminContract.methods.LRSCAddress().call();

        setLandRegistrationSC({
            address: LRSC,
            abi: LandRegistration.abi
        });

        const LOSC = await MCAdminContract.methods.LOSCAddress().call();

        setLoanOriginatorSC({
            address: LOSC,
            abi: LoanOriginator.abi
        });

        const SPV = await MCAdminContract.methods.SPVWalletAddress().call();

        setSPVWalletSC({
            address: SPV,
            abi: SPVWallet.abi
        });

    }, [web3Context]);

    useEffect(() => {
        if(web3Context.active) {
            loadSCAddress();
            getActiveLoanPools();
            // work around of the async call issue
            loadBoardMembers();
            setLoading(false);
        }
    },[web3Context]);

    // work around about the delay setState issue
    useEffect(() => {
        getActiveDeveloperDetails();
    }, [boardMembers, getActiveDeveloperDetails]);

    return (
        <DashboardPage>
        <TitleRow>
            <Title>Governance Market</Title>
            {web3Context.account !== undefined && boardMembers !== undefined && boardMembers.includes(web3Context.account)
                ? (<ActionButtonContainer>
                        <CreateMarketModal action={createLoanPool} />
                   </ActionButtonContainer>
                ) : ("")}
        </TitleRow>
            <FlexContainer>
                <TableContainer>
                    <StyledTable>
                        <thead>
                        <tr>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('loanPoolName')}>Market
                                    <span>{sortConfig !== null && sortConfig.key === 'loanPoolName' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('marketsize')}>Market Size
                                    <span>{sortConfig !== null && sortConfig.key === 'marketsize' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('rateToBorrow')}>Current Yield
                                    <span>{sortConfig !== null && sortConfig.key === 'rateToBorrow' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('maxRate')}>Maximum Yield
                                    <span>{sortConfig !== null && sortConfig.key === 'maxRate' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('minRate')}>Minimum Yield
                                    <span>{sortConfig !== null && sortConfig.key === 'minRate' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('currentUltilizationRate')}>Utilization Rate
                                    <span>{sortConfig !== null && sortConfig.key === 'currentUltilizationRate' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('currency')}>Currency
                                    <span>{sortConfig !== null && sortConfig.key === 'currency' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            {
                                web3Context.account !== undefined && boardMembers !== undefined && boardMembers.includes(web3Context.account) ? (<th>Action</th>):("")
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {web3Context.account === undefined || items === undefined ||  items === [] ? (<Spinner/>) : items.map((loanPool, index) => {
                            return (
                                <tr key={index}>
                                    <td id="name"><StyledNavLink to={'/loanpool/' + loanPool.loanPoolID}>{loanPool.loanPoolName}</StyledNavLink></td>
                                    <td><StyledNavLink to={'/loanpool/' + loanPool.loanPoolID}>${loanPool.marketsize.toFixed(2)}</StyledNavLink></td>
                                    <td><StyledNavLink to={'/loanpool/' + loanPool.loanPoolID}>{loanPool.rateToBorrow.toFixed(2)}%</StyledNavLink></td>
                                    <td><StyledNavLink to={'/loanpool/' + loanPool.loanPoolID}>{loanPool.maxRate.toFixed(2)}%</StyledNavLink></td>
                                    <td><StyledNavLink to={'/loanpool/' + loanPool.loanPoolID}>{loanPool.minRate.toFixed(2)}%</StyledNavLink></td>
                                    <td><StyledNavLink to={'/loanpool/' + loanPool.loanPoolID}>{loanPool.currentUltilizationRate.toFixed(2)}%</StyledNavLink></td>
                                    <td><StyledNavLink to={'/loanpool/' + loanPool.loanPoolID}>{loanPool.currencyName}</StyledNavLink></td>
                                    {
                                        web3Context.account !== undefined && boardMembers !== undefined && boardMembers.includes(web3Context.account) && loanPool.status === "0" ? (
                                            <td id="action">
                                                <ActionButtonRow>
                                                    <CreateLoanModal action={withdrawFund} developerInfos={activeDevelopers} loanPool = {loanPool} />
                                                    <PayLoanModal action = {payLoan} developerInfos={activeDevelopers} loanPool = {loanPool} />
                                                    <CloseMarketModal action = {closeMarket} loanPoolName = {loanPool.loanPoolName} loanPoolID = {loanPool.loanPoolID} status ={loanPool.status} />
                                                    <LiquidateLandModal action = {liquidateLand} developerInfos={activeDevelopers} loanPool = {loanPool} />
                                                </ActionButtonRow>
                                            </td>):("")
                                    }
                                    {
                                        web3Context.account !== undefined && boardMembers !== undefined && boardMembers.includes(web3Context.account) && loanPool.status === "1" ? (
                                            <td id="action">
                                                <ActionButtonRow>
                                                    <CloseMarketModal action = {openMarket} loanPoolName = {loanPool.loanPoolName} loanPoolID = {loanPool.loanPoolID} status ={loanPool.status} />
                                                </ActionButtonRow>
                                            </td>):("")
                                    }
                                </tr>
                            )
                        })}
                        </tbody>
                    </StyledTable>
                </TableContainer>
            </FlexContainer>
        </DashboardPage>);
};

export default MarketDashboardPage;
